import { Card, Text } from "@mantine/core";
import React from "react";
import Chart from "react-apexcharts";

export default function TotalFeedback({
  data = [0, 0, 0],
  labels = ["Feedback", "Complaint", "Suggestion"],
}) {
  const [chartData, setChartData] = React.useState(null);

  React.useEffect(() => {
    setTimeout(() => {
      setChartData(options);
    }, 100);
  }, [data]);

  const options = {
    type: "pie",
    series: data,
    height: 500,
    options: {
      labels: labels,
      legend: {
        show: true,
        fontSize: "14px",
        fontFamily: `'Roboto', sans-serif`,
        position: "bottom",
        labels: {
          useSeriesColors: false,
        },
      },
    },
  };
  return (
    <div>
      {chartData ? <Chart {...chartData} width="100%" /> : "Loading..."}
    </div>
  );
}
